<template>
  <div
    class="z-50 flex-col  w-full flex-1 "
    v-mousedown-outside="outsideHandler"
    id="colorstrip"
  >
    <div class="toollabel pl-2">COLOUR</div>

    <div class="colorswrapper overflow-x-auto pl-2 whitespace-no-wrap">
      <!-- <button
        class="flex rounded-md uibtn justify-start items-center text-xs p-1"
        @click.prevent="toggle"
      >
        <div
          class="w-8 h-8 lg:w-12 lg:h-12 m-r-2 z-30 rounded-md border-gray-100 border  m/2"
          :style="{ background: selectedColour }"
        ></div>
      </button> -->
      <!-- <div
        class="swatches mx-auto flex border-l ml-2 border-gray-100 border-solid ml-16  pl-3 items-center justify-center h-8"
      > -->

      <button
        class="h-12 w-12  inline-flex justify-center items-center relative rounded-full mr-2 border border-red-100 border-dashed text-red-100 text-xl"
        @click="addNewColor"
      >
        <span>+</span>
      </button>
      <Swatch
        v-for="(swatch, i) in swatches"
        :key="i"
        v-model="swatches[i]"
        :color="swatches[i]"
        @click.native.stop="handleEmitColour(i)"
        @dblclick.native.stop="handleChangeColour(i)"
        class=""
        :active="swatches[i] == selectedColour
        "
        :class="{ active: swatches[i] == selectedColour }"
      />
    </div>
    <!-- </div> -->



    <transition name="fade">
      <div
        class="wheel-wrapper absolute bg-white box-content rounded  shadow-xl flex flex-col justify-center items-center z-20 shadow-lg border border-red-100"
        v-show="isOpen"
      >
      
      <div class="wheelheader text-red-100 h-12">
        <span v-if="!currentIndex">Add new colour</span>
        <span v-else>Replace colour</span>
      </div>
        <div class="m-4">
          <chrome-picker
            v-model="colors"
            startColor="swatches[0]"
            @click.prevent=""
            :width="220"
            :height="220"
          ></chrome-picker>
        </div>
<div>
        <div class="h-12 w-12 block rounded-full" :style="{backgroundColor:selectedColour}"></div>
      </div>
        <button
          @click="cancel"
          class="w-12 h-12 text-red-100 hover:text-red-100 text-2xl  pt-4 absolute z-50 hover:text-red cancel "
        >
          &times;
        </button>

        <div
          id="wheel-footer"
          class="w-full  h-12 rounded-br-md rounded-bl-md flex justify-end"
        >
          <div class=""></div>
          <button
            @click="confirmColour"
            id="accept"
            class="flex items-center justify-center text-black hover:text-red-100  py-2 px-4 absolute bottom-0 right-0 z-50 rounded-md mr-1 mb-1 border-red-100 border border-solid text-red-100"
          >
            <span v-if="!currentIndex" >Add</span><span v-else>Replace</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ColorPicker from "vue-color-picker-wheel";
import Swatch from "@/components/Swatch.vue";
// import * as Hammer from "hammerjs";
// import VueTapOutside from "vue-tap-outside";
// import { Draggable } from "draggable-vue-directive";
// import ClickOutside from "vue-click-outside";
// import Moveable from "vue-moveable";

export default {
  name: "ColourWheel",
  components: {
    "chrome-picker": ColorPicker,
    Swatch,
    // Moveable,
  },
  data: function() {
    return {
      showUi: true,
      isOpen: false,
      prevColor: "",
      swatches: ["#ff3c39"],
      colors: "#ff3c39",
      currentIndex: false,
    };
  },
  computed: {
    selectedColour: {
      get: function() {
        if (typeof this.colors == "object" && this.colors.hex !== undefined) {
          return this.colors.hex;
        } else {
          return this.colors;
        }
      },
      set: function(newValue) {
        this.colors = newValue;
      },
    },
    textColor: {
      get: function() {
        return this.setContrast(this.hexToRgb(this.colors));
      },
    },
  },
  directives: {},
  watch: {
    showUi: function(newval, oldval) {
      if (newval == false) {
        this.outsideHandler();
        // this.showUi=true;
      }
    },
    selectedColour: function(newColour, oldColour) {
      this.emitColour();
    },
    isOpen: function(newState, oldState) {
      this.prevColor = this.selectedColour;
      this.emitState(newState);
    },
  },
  methods: {
     hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
  parseInt(result[1], 16),
  parseInt(result[2], 16),
  parseInt(result[3], 16)
   ] : null;
},

setContrast(rgb) {
  // Randomly update colours
  rgb[0] = Math.round(Math.random() * 255);
  rgb[1] = Math.round(Math.random() * 255);
  rgb[2] = Math.round(Math.random() * 255);

  // http://www.w3.org/TR/AERT#color-contrast
  const brightness = Math.round(((parseInt(rgb[0]) * 299) +
                      (parseInt(rgb[1]) * 587) +
                      (parseInt(rgb[2]) * 114)) / 1000);
  const textColour = (brightness > 125) ? 'black' : 'white';
  const backgroundColour = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';

    return textColour;

    },

    cancel() {
      // this.selectedColour = this.colors = this.prevColor;
      this.isOpen = false;
    },
    outsideHandler(e) {
      // console.e);
      // this.cancel()
      this.isOpen = false;
    },
    toggle: function() {
      this.isOpen = !this.isOpen;
    },
    isInSwatches() {
      return this.swatches.find((el) => el === this.selectedColour) === true;
    },
    addNewColor() {
      this.currentIndex = false;
      this.toggle();
    },
    addSwatch() {
      if (
        this.swatches.find((el) => el === this.selectedColour) === undefined
      ) {
        this.swatches.unshift(this.selectedColour);
        this.isOpen = false;
        // if (this.swatches.length >= 8) {
        //   this.swatches.shift();
        // }

        localStorage.swatches = JSON.stringify(this.swatches);
      }
    },
    removeSwatch(i) {
      this.swatches.splice(i, 1);
      localStorage.swatches = JSON.stringify(this.swatches);
    },
    emitColour() {
      this.$emit("selectColour", this.selectedColour);
    },
    confirmColour() {
      if (this.currentIndex == false) {
        this.addSwatch();
      } else {
        this.swatches.splice(this.currentIndex, 1, this.selectedColour);
        this.isOpen = false;
      }
    },
    selectColour(value) {
      this.selectedColour = value;
      this.isOpen = false;
    },
    emitState(v) {
      this.$emit("isOpen", v);
    },
    handleEmitColour(i) {
      if (this.swatches[i] == false) {
        if (!this.swatches.find((el) => el == this.selectedColour)) {
          this.swatches.splice(i, 1, this.selectedColour);
        }
      } else {
        this.selectColour(this.swatches[i]);
        this.currentIndex = i;
      }
    },
    handleChangeColour(i) {
      this.currentIndex = i;
      this.toggle();
    },
  },
  mounted() {
    if (localStorage.swatches !== undefined) {
      this.swatches = JSON.parse(localStorage.swatches);
    }
    this.colors = this.swatches[0];
  },
};
</script>

<style>
.wheel-wrapper {
  position: absolute;
  top: calc(50% - 14rem);
  left: calc(50% - 9rem);
  min-height: 15rem;
  padding: .5rem 1rem 1rem 1rem;
}

.wheel-wrapper.open {
  bottom: 1rem;
  top: 0;
}

.cancel {
  top: -1rem;
  right: -0.5rem;
}

.colorbtnwrapper {
  border-right: 1px solid gray;
}
.colorswrapper::-webkit-scrollbar {
  display: none;
  height: 0px;
  background: transparent;
}
.swatches > button {
}

#swatches {
}
/* 
::-webkit-scrollbar {
  width: 0px;
  background: transparent; 
} */

</style>
